import React, { useContext, useEffect, useState } from "react";
import CommonModal from "../CommonModal";
import ManageDomainName from "../../Pages/Admin/Organisation/ManageDomainName";
import { networkService } from "../../config/axios";
import CustomTable from "../../CommonComponents/Table/CustomTable";
import DeleteOrgModal from "./DeleteOrgModal";
import UserInfoContext from "../../../utils/userInfoContext";
import { AdminActionIcons } from "../../Admin/Shared";
import "../../Admin/Shared/AdminModal.css";

const ManageDomain = ({ openModal, closeModal, companyId }) => {
  const { setShowNotifications } = useContext(UserInfoContext);
  const [show, setShow] = useState('list');
  const [domains, setDomains] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [domain, setDomain] = useState({});

  const handleAddDomain = () => {
    setDomain({});
    setShow('form');
  };

  useEffect(() => {
    if (!openModal || !companyId) return;
    const fetchDomains = async () => {
      const response = await networkService(`admin/company-domains/${companyId}.json`, "GET");
      setDomains([...response.data]);
    };
    fetchDomains();
  }, [openModal, companyId, show, openDelete]);

  const columns = React.useMemo(
    () => [
      { Header: 'Domain', accessor: 'name' },
      { Header: 'Created By', accessor: 'creator' },
      { Header: 'Modified By', accessor: 'modifier' },
      {
        Header: 'Actions',
        accessor: 'action',
        Cell: ({ row }) => (
          <AdminActionIcons
            itemName={row.original.name}
            onEdit={() => {
              setShow('form');
              setDomain(row?.original);
            }}
            onDelete={() => {
              setOpenDelete(true);
              setDomain(row?.original);
            }}
          />
        ),
      },
    ],
    []
  );

  const handleDeleteDomain = () => {
    const url = `admin/company_domains/${domain?.id}.json`;
    networkService(url, "DELETE")
      .then((response) => {
        if (response.status == 204) {
          setOpenDelete(false);
          setShowNotifications({
            showToast: true,
            toastType: "success",
            toastMessage: 'Domain successfully deleted',
          });
        }
      })
      .catch((err) => {
        console.error(err);
        setShowNotifications({
          showToast: true,
          toastType: "danger",
          toastMessage: 'something went wrong!',
        });
      });
  };

  return (
    <CommonModal
      title={"Manage Domains"}
      modalStatus={openModal}
      changeActiveStatus={() => closeModal()}
      classList="admin-modal admin-domain-modal"
      centered
      showFooter={false}
    >
      {openDelete && (
        <DeleteOrgModal
          title={'Are you sure?'}
          openModal={openDelete}
          closeModal={setOpenDelete}
          name={'delete ' + domain?.name}
          handleDelete={() => handleDeleteDomain()}
        />
      )}

      {show === 'list' ? (
        <div className="domain-list-view">
          <div className="admin-table-wrapper">
            <CustomTable data={domains} columnData={columns} showFilters={false} />
          </div>
          <div className="admin-list-footer">
            <button
              type="button"
              className="admin-cta-button"
              onClick={handleAddDomain}
            >
              + ADD Domain
            </button>
          </div>
        </div>
      ) : (
        <div className="domain-form-view">
          <ManageDomainName setShow={setShow} companyId={companyId} domain={domain} />
        </div>
      )}
    </CommonModal>
  );
};
export default ManageDomain;
